<div class="progress-card">
  <div class="card-left-section">
    <div class="card-header">
      <mat-icon>{{ progressCard.icon }}</mat-icon>
      <div class="title">{{ progressCard.title | translate }}</div>
    </div>
    <qa-progress-status-bar
      [progressBarData]="progressCard.progress"
    ></qa-progress-status-bar>
  </div>
  <div class="card-right-section">
    <qa-progress-status-steps
      [steps]="progressCard.steps"
      [tourType]="progressCard.tourType"
      [isStepper]="false"
    ></qa-progress-status-steps>
  </div>
</div>
